<!--
  File name: Footer.vue
  Program Description:
    - This component renders the footer displayed across the system.

-->

<template>
  <v-footer
    app
    color="transparent"
    flat
    absolute
    class="justify-center ma-auto"
  >
    <v-card
      flat
      tile
      color="transparent"
    >
      <v-card-text class="pa-0">
        <TermsLogin />
      </v-card-text>
      <v-card-text class="text-center pa-0">
        <span>
          v2.0.0.6
        </span>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
import TermsLogin from '@/components/TermsLogin'
export default {
  name: 'Footer',
  components: {
    TermsLogin
  },
  props: {
  },
  data: function () {
    return {
      openDialog: false
    }
  }
}
</script>

<style scoped>
.v-footer{
  width: 100%
}
</style>
